<template>
    <div>
        <form action="">
            <div class="modal-card" style="width: auto">
                <header class="modal-card-head">
                    <p class="modal-card-title">Duplicate game: <strong>{{ gameName }}</strong></p>
                </header>
                <section class="modal-card-body">
                    <div class="textIntro">
                        <p>
                            The map, pack, activities and parameters for this game will be duplicated.
                        </p>
                        <p v-if="packExistsForThisGame">
                            <b-icon icon="check" size="is-small" type="is-success"></b-icon>
                            <span style="vertical-align: top; color: #74b996">The new game can be edited.
                            </span>
                        </p>
                        <p v-else>
                            <b-icon icon="alert" size="is-small" type="is-danger"></b-icon>
                            <span style="vertical-align: top; color: #c55558">The new game cannot be edited since the associated pack has been deleted
                                but is still playable.
                            </span>
                        </p>
                    </div>

                    <hr/>
                    <b-collapse :open="false" style="padding-bottom: 20px; margin-top: -10px">
                        <a slot="trigger" slot-scope="props">
                            <b-icon :icon="!props.open ? 'menu-right' : 'menu-up'"></b-icon>
                            <span style="font-style: italic; vertical-align: top">Options</span>
                        </a>
                        <div style="padding-top: 10px"></div>

                        <b-field label-position="inside" label="New name">
                            <b-input v-model="newGameName"></b-input>
                        </b-field>

                        <b-switch v-model="duplicateTeamsSwitch">Duplicate teams</b-switch>

                    </b-collapse>

                </section>
                <footer class="modal-card-foot">
                    <button class="button" type="button" @click="$parent.close()">Cancel</button>
                    <button class="button is-primary" @click="duplicateGame">Duplicate</button>
                </footer>
            </div>
        </form>

        <b-loading :is-full-page="true" :active.sync="isLoading" :canCancel="false"></b-loading>
    </div>
</template>

<script>
  import gamesService from '../../services/gamesService'
  import packService from '../../services/packService'
  import displayHelper from '../../helpers/display-helper'

  export default {
    components: {},
    props: {
      game: null,
    },
    data() {
      return {
        newGameName: '',
        duplicateTeamsSwitch: false,
        isLoading: false,
        gameName: '',
        packExistsForThisGame: true,
      }
    },
    created() {
      this.gameName = this.game.gameName
      this.newGameName = this.gameName

      if (this.game.wizardInformation && this.game.wizardInformation.chosenPack) {
        packService.getPackById(this.game.wizardInformation.chosenPack.packId)
          .then((pack) => {
            // the pack exists in the database, all good
            console.log('ok')
            this.packExistsForThisGame = true
          })
          .catch((err) => {
            // the pack does not exist, the game can be played but not edited
            console.log('err!')
            this.packExistsForThisGame = false
          })
      }
    },
    methods: {
      duplicateGame() {
        this.isLoading = true
        var parent = this

        gamesService.duplicateGameWithWizard(this.game, this.game.idGame, this.newGameName, this.duplicateTeamsSwitch)
          .then(() => {
            this.isLoading = false
            displayHelper.displaySuccess(parent, 'Game has been duplicated successfully')
            this.$emit('finishDuplicate')
            this.$parent.close()
          })
          .catch((err) => {
            displayHelper.displayError(parent, 'Oops, there was an error while duplicating the game: ' + err.message)
            this.isLoading = false
          })
      }
    },
  }
</script>
<style scoped>
    .textIntro {
        font-style: italic;
    }

    .btn-margin {
        margin-left: 10px;
        margin-right: 10px;
    }
</style>
